import type { FC } from "react";
import type { IconProps } from "./Icon";
import Icon from "./Icon";
import type { IconType } from "./Icon.types";
import icons from "./Icon.types";

type IconPresetProps = Omit<IconProps, "name">;
export type IconPreset = FC<IconPresetProps> & { __isIcon: true };

const map = Object.keys(icons).map((key) => {
    const newKey: Capitalize<IconType> = (key.charAt(0).toUpperCase() +
        key.slice(1)) as Capitalize<IconType>;
    const value = ((rest: IconPresetProps) => (
        <Icon name={key as IconType} {...rest} />
    )) as IconPreset;

    value.__isIcon = true;

    return [newKey, value];
});

export const iconMap: Record<
    Capitalize<IconType>,
    IconPreset
> = Object.fromEntries(map);
